import { useLayout, LayoutType } from '@/contexts/LayoutContext';
import Layout1Header from './layout-1/Header';
import Layout1Index from './layout-1/Index';
import Layout1Footer from './layout-1/Footer';
import Layout1Hero from './layout-1/Hero';
import Layout1VehicleCard from './layout-1/VehicleCard';
import Layout1RecentlyViewedVehicles from './layout-1/RecentlyViewedVehicles';
import Layout1VehicleDetail from './layout-1/VehicleDetail';
import Layout1VehiclesListing from './layout-1/VehiclesListing';
import Layout1Contact from './layout-1/Contact';
import Layout1Services from './layout-1/Services';
import Layout1Favorites from './layout-1/Favorites';
import Layout1PrivacyPolicy from './layout-1/PrivacyPolicy';
import Layout1TermsOfUse from './layout-1/TermsOfUse';
import Layout1NotFound from './layout-1/NotFound';
import Layout1BannerVehicles from './layout-1/BannerVehicles';

import { Header as Layout2Header } from './layout-2/Header';
import Layout2Index from './layout-2/Index';
import { Footer as Layout2Footer } from './layout-2/Footer';
import { Hero as Layout2Hero } from './layout-2/Hero';
import { VehicleCard as Layout2VehicleCard } from './layout-2/VehicleCard';
import { RecentlyViewedVehicles as Layout2RecentlyViewedVehicles } from './layout-2/RecentlyViewedVehicles';
import Layout2VehicleDetail from './layout-2/VehicleDetail';
import Layout2VehiclesListing from './layout-2/VehiclesListing';
import Layout2Contact from './layout-2/Contact';
import Layout2Services from './layout-2/Services';
import Layout2Favorites from './layout-2/Favorites';
import Layout2PrivacyPolicy from './layout-2/PrivacyPolicy';
import Layout2TermsOfUse from './layout-2/TermsOfUse';
import Layout2NotFound from './layout-2/NotFound';
import Layout2BannerVehicles from './layout-2/BannerVehicles';

import { Header as Layout3Header } from './layout-3/Header';
import Layout3Index from './layout-3/Index';
import { Footer as Layout3Footer } from './layout-3/Footer';
import { Hero as Layout3Hero } from './layout-3/Hero';
import { VehicleCard as Layout3VehicleCard } from './layout-3/VehicleCard';
import { RecentlyViewedVehicles as Layout3RecentlyViewedVehicles } from './layout-3/RecentlyViewedVehicles';
import Layout3VehicleDetail from './layout-3/VehicleDetail';
import Layout3VehiclesListing from './layout-3/VehiclesListing';
import Layout3Contact from './layout-3/Contact';
import Layout3Services from './layout-3/Services';
import Layout3Favorites from './layout-3/Favorites';
import Layout3PrivacyPolicy from './layout-3/PrivacyPolicy';
import Layout3TermsOfUse from './layout-3/TermsOfUse';
import Layout3NotFound from './layout-3/NotFound';
import Layout3BannerVehicles from './layout-3/BannerVehicles';

import { Header as Layout4Header } from './layout-4/Header';
import Layout4Index from './layout-4/Index';
import { Footer as Layout4Footer } from './layout-4/Footer';
import { Hero as Layout4Hero } from './layout-4/Hero';
import { VehicleCard as Layout4VehicleCard } from './layout-4/VehicleCard';
import { RecentlyViewedVehicles as Layout4RecentlyViewedVehicles } from './layout-4/RecentlyViewedVehicles';
import Layout4VehicleDetail from './layout-4/VehicleDetail';
import Layout4VehiclesListing from './layout-4/VehiclesListing';
import Layout4Contact from './layout-4/Contact';
import Layout4Services from './layout-4/Services';
import Layout4Favorites from './layout-4/Favorites';
import Layout4PrivacyPolicy from './layout-4/PrivacyPolicy';
import Layout4TermsOfUse from './layout-4/TermsOfUse';
import Layout4NotFound from './layout-4/NotFound';
import Layout4BannerVehicles from './layout-4/BannerVehicles';

import { Header as Layout5Header } from './layout-5/Header';
import Layout5Index from './layout-5/Index';
import { Footer as Layout5Footer } from './layout-5/Footer';
import { Hero as Layout5Hero } from './layout-5/Hero';
import { VehicleCard as Layout5VehicleCard } from './layout-5/VehicleCard';
import { RecentlyViewedVehicles as Layout5RecentlyViewedVehicles } from './layout-5/RecentlyViewedVehicles';
import Layout5VehicleDetail from './layout-5/VehicleDetail';
import Layout5VehiclesListing from './layout-5/VehiclesListing';
import Layout5Contact from './layout-5/Contact';
import Layout5Services from './layout-5/Services';
import Layout5Favorites from './layout-5/Favorites';
import Layout5PrivacyPolicy from './layout-5/PrivacyPolicy';
import Layout5TermsOfUse from './layout-5/TermsOfUse';
import Layout5NotFound from './layout-5/NotFound';
import Layout5BannerVehicles from './layout-5/BannerVehicles';

import { Header as Layout6Header } from './layout-6/Header';
import Layout6Index from './layout-6/Index';
import { Footer as Layout6Footer } from './layout-6/Footer';
import { Hero as Layout6Hero } from './layout-6/Hero';
import { VehicleCard as Layout6VehicleCard } from './layout-6/VehicleCard';
import { RecentlyViewedVehicles as Layout6RecentlyViewedVehicles } from './layout-6/RecentlyViewedVehicles';
import Layout6VehicleDetail from './layout-6/VehicleDetail';
import Layout6VehiclesListing from './layout-6/VehiclesListing';
import Layout6Contact from './layout-6/Contact';
import Layout6Services from './layout-6/Services';
import Layout6Favorites from './layout-6/Favorites';
import Layout6PrivacyPolicy from './layout-6/PrivacyPolicy';
import Layout6TermsOfUse from './layout-6/TermsOfUse';
import Layout6NotFound from './layout-6/NotFound';
import Layout6BannerVehicles from './layout-6/BannerVehicles';

import { Header as Layout7Header } from './layout-7/Header';
import Layout7Index from './layout-7/Index';
import { Footer as Layout7Footer } from './layout-7/Footer';
import { Hero as Layout7Hero } from './layout-7/Hero';
import { VehicleCard as Layout7VehicleCard } from './layout-7/VehicleCard';
import { RecentlyViewedVehicles as Layout7RecentlyViewedVehicles } from './layout-7/RecentlyViewedVehicles';
import Layout7VehicleDetail from './layout-7/VehicleDetail';
import Layout7VehiclesListing from './layout-7/VehiclesListing';
import Layout7Contact from './layout-7/Contact';
import Layout7Services from './layout-7/Services';
import Layout7Favorites from './layout-7/Favorites';
import Layout7PrivacyPolicy from './layout-7/PrivacyPolicy';
import Layout7TermsOfUse from './layout-7/TermsOfUse';
import Layout7NotFound from './layout-7/NotFound';
import Layout7BannerVehicles from './layout-7/BannerVehicles';

type LayoutComponents = {
  Header: React.ComponentType<any>;
  Footer: React.ComponentType<any>;
  Hero: React.ComponentType<any>;
  VehicleCard: React.ComponentType<any>;
  RecentlyViewedVehicles: React.ComponentType<any>;
  Index: React.ComponentType;
  VehicleDetail: React.ComponentType;
  VehiclesListing: React.ComponentType;
  Contact: React.ComponentType;
  Services: React.ComponentType;
  Favorites: React.ComponentType;
  PrivacyPolicy: React.ComponentType;
  TermsOfUse: React.ComponentType;
  NotFound: React.ComponentType;
  BannerVehicles: React.ComponentType;
};

const LAYOUT_REGISTRY: Record<LayoutType, LayoutComponents> = {
  'layout-1': {
    Header: Layout1Header,
    Footer: Layout1Footer,
    Hero: Layout1Hero,
    VehicleCard: Layout1VehicleCard,
    RecentlyViewedVehicles: Layout1RecentlyViewedVehicles,
    Index: Layout1Index,
    VehicleDetail: Layout1VehicleDetail,
    VehiclesListing: Layout1VehiclesListing,
    Contact: Layout1Contact,
    Services: Layout1Services,
    Favorites: Layout1Favorites,
    PrivacyPolicy: Layout1PrivacyPolicy,
    TermsOfUse: Layout1TermsOfUse,
    NotFound: Layout1NotFound,
    BannerVehicles: Layout1BannerVehicles,
  },
  'layout-2': {
    Header: Layout2Header,
    Footer: Layout2Footer,
    Hero: Layout2Hero,
    VehicleCard: Layout2VehicleCard,
    RecentlyViewedVehicles: Layout2RecentlyViewedVehicles,
    Index: Layout2Index,
    VehicleDetail: Layout2VehicleDetail,
    VehiclesListing: Layout2VehiclesListing,
    Contact: Layout2Contact,
    Services: Layout2Services,
    Favorites: Layout2Favorites,
    PrivacyPolicy: Layout2PrivacyPolicy,
    TermsOfUse: Layout2TermsOfUse,
    NotFound: Layout2NotFound,
    BannerVehicles: Layout2BannerVehicles,
  },
  'layout-3': {
    Header: Layout3Header,
    Footer: Layout3Footer,
    Hero: Layout3Hero,
    VehicleCard: Layout3VehicleCard,
    RecentlyViewedVehicles: Layout3RecentlyViewedVehicles,
    Index: Layout3Index,
    VehicleDetail: Layout3VehicleDetail,
    VehiclesListing: Layout3VehiclesListing,
    Contact: Layout3Contact,
    Services: Layout3Services,
    Favorites: Layout3Favorites,
    PrivacyPolicy: Layout3PrivacyPolicy,
    TermsOfUse: Layout3TermsOfUse,
    NotFound: Layout3NotFound,
    BannerVehicles: Layout3BannerVehicles,
  },
  'layout-4': {
    Header: Layout4Header,
    Footer: Layout4Footer,
    Hero: Layout4Hero,
    VehicleCard: Layout4VehicleCard,
    RecentlyViewedVehicles: Layout4RecentlyViewedVehicles,
    Index: Layout4Index,
    VehicleDetail: Layout4VehicleDetail,
    VehiclesListing: Layout4VehiclesListing,
    Contact: Layout4Contact,
    Services: Layout4Services,
    Favorites: Layout4Favorites,
    PrivacyPolicy: Layout4PrivacyPolicy,
    TermsOfUse: Layout4TermsOfUse,
    NotFound: Layout4NotFound,
    BannerVehicles: Layout4BannerVehicles,
  },
  'layout-5': {
    Header: Layout5Header,
    Footer: Layout5Footer,
    Hero: Layout5Hero,
    VehicleCard: Layout5VehicleCard,
    RecentlyViewedVehicles: Layout5RecentlyViewedVehicles,
    Index: Layout5Index,
    VehicleDetail: Layout5VehicleDetail,
    VehiclesListing: Layout5VehiclesListing,
    Contact: Layout5Contact,
    Services: Layout5Services,
    Favorites: Layout5Favorites,
    PrivacyPolicy: Layout5PrivacyPolicy,
    TermsOfUse: Layout5TermsOfUse,
    NotFound: Layout5NotFound,
    BannerVehicles: Layout5BannerVehicles,
  },
  'layout-6': {
    Header: Layout6Header,
    Footer: Layout6Footer,
    Hero: Layout6Hero,
    VehicleCard: Layout6VehicleCard,
    RecentlyViewedVehicles: Layout6RecentlyViewedVehicles,
    Index: Layout6Index,
    VehicleDetail: Layout6VehicleDetail,
    VehiclesListing: Layout6VehiclesListing,
    Contact: Layout6Contact,
    Services: Layout6Services,
    Favorites: Layout6Favorites,
    PrivacyPolicy: Layout6PrivacyPolicy,
    TermsOfUse: Layout6TermsOfUse,
    NotFound: Layout6NotFound,
    BannerVehicles: Layout6BannerVehicles,
  },
  'layout-7': {
    Header: Layout7Header,
    Footer: Layout7Footer,
    Hero: Layout7Hero,
    VehicleCard: Layout7VehicleCard,
    RecentlyViewedVehicles: Layout7RecentlyViewedVehicles,
    Index: Layout7Index,
    VehicleDetail: Layout7VehicleDetail,
    VehiclesListing: Layout7VehiclesListing,
    Contact: Layout7Contact,
    Services: Layout7Services,
    Favorites: Layout7Favorites,
    PrivacyPolicy: Layout7PrivacyPolicy,
    TermsOfUse: Layout7TermsOfUse,
    NotFound: Layout7NotFound,
    BannerVehicles: Layout7BannerVehicles,
  },
};

const useLayoutComponents = () => {
  const { currentLayout } = useLayout();
  return LAYOUT_REGISTRY[currentLayout];
};

export const LayoutHeader = (props: any) => {
  const { Header } = useLayoutComponents();
  return <Header {...props} />;
};

export const LayoutFooter = (props: any) => {
  const { Footer } = useLayoutComponents();
  return <Footer {...props} />;
};

export const LayoutHero = (props: any) => {
  const { Hero } = useLayoutComponents();
  return <Hero {...props} />;
};

export const LayoutVehicleCard = (props: any) => {
  const { VehicleCard } = useLayoutComponents();
  return <VehicleCard {...props} />;
};

export const LayoutRecentlyViewedVehicles = (props: any) => {
  const { RecentlyViewedVehicles } = useLayoutComponents();
  return <RecentlyViewedVehicles {...props} />;
};

export const LayoutIndex = () => {
  const { Index } = useLayoutComponents();
  return <Index />;
};

export const LayoutVehicleDetail = () => {
  const { VehicleDetail } = useLayoutComponents();
  return <VehicleDetail />;
};

export const LayoutVehiclesListing = () => {
  const { VehiclesListing } = useLayoutComponents();
  return <VehiclesListing />;
};

export const LayoutContact = () => {
  const { Contact } = useLayoutComponents();
  return <Contact />;
};

export const LayoutServices = () => {
  const { Services } = useLayoutComponents();
  return <Services />;
};

export const LayoutFavorites = () => {
  const { Favorites } = useLayoutComponents();
  return <Favorites />;
};

export const LayoutPrivacyPolicy = () => {
  const { PrivacyPolicy } = useLayoutComponents();
  return <PrivacyPolicy />;
};

export const LayoutTermsOfUse = () => {
  const { TermsOfUse } = useLayoutComponents();
  return <TermsOfUse />;
};

export const LayoutNotFound = () => {
  const { NotFound } = useLayoutComponents();
  return <NotFound />;
};

export const LayoutBannerVehicles = () => {
  const { BannerVehicles } = useLayoutComponents();
  return <BannerVehicles />;
};
